import React, { useState, useEffect } from "react";
import { Textarea } from "../Form";
import { stage3 as v } from "../../pages/Rfp/validate";
import { Field, reduxForm } from "redux-form";
import { connect, useSelector } from "react-redux";
import { saveCompanyNote } from "../../services/companyService/companyNoteService";
import { isRolePlatformAdmin, token } from "../../modules/auth";
import Loading from "../Loading";
import moment from "moment";
import {
  fetchCompanyFiles,
  removeCompanyFile,
  uploadCompanyFile,
} from "../../redux/actions/company-files";
import { editCompany } from "../../redux/actions";
import { ButtonPrimary } from "../Button";
import { handleDownload } from "../../services/downloadFile";
import { preAddUrl } from "../../utils";

const mapStateToProps = (state, props) => {
  return {
    ...state.companyFiles,
    token: token(state),
    isRolePlatformAdmin: isRolePlatformAdmin(state),
  };
};

const mapDispatchToProps = {
  fetchCompanyFiles,
};

let CompanyNoteField = ({
  fetchCompanyFiles,
  companyFiles,
  token,
  company,
  note,
  displayNote = false,
}) => {
  const [content, setContent] = useState(null);
  const [saving, setSaving] = useState(false);
  const [updatedBy, setUpdatedBy] = useState(note ? note.owner_name : null);
  const [updatedAt, setUpdatedAt] = useState(note ? note.updated_at : null);
  useEffect(() => {
    fetchCompanyFiles(company.id, token);
  }, []);

  useEffect(() => {
    if (content) {
      setSaving(true);
      const delayDebounceFn = setTimeout(() => {
        saveCompanyNote(token, content, company.id).then(r => {
          setSaving(false);
          setUpdatedBy(r.result.updatedBy);
          setUpdatedAt(r.result.updatedAt);
        });
        // Send Axios request here
      }, 1000);

      return () => clearTimeout(delayDebounceFn);
    }
  }, [content]);

  if (!note && displayNote) {
    return <></>;
  }

  if (displayNote) {
    return (
      <div>
        <div className={"p-5 bg-grey"}>
          <strong className={"strong"}>Internal Note:</strong>
          <p>{note.content}</p>
          <p>
            <span>
              Last updated by {updatedBy} at{" "}
              {moment(updatedAt).format("DD/MM/YYYY h:mm:ss")}{" "}
            </span>
          </p>
        </div>
        <div className={"flex flex-wrap my-2"}>
          {companyFiles && companyFiles.length > 0
            ? companyFiles.map(file => {
                return typeof file.path !== "undefined" && file.path ? (
                  <a
                    className={"text-sm font-medium  pr-2 py-2"}
                    href="#"
                    onClick={() =>
                      handleDownload(
                        file?.name,
                        file?.url,
                        file?.extension,
                        token
                      )
                    }
                  >
                    <ButtonPrimary>{file.name}</ButtonPrimary>
                  </a>
                ) : (
                  <a
                    className={"text-sm font-medium  pr-2 py-2 "}
                    href={preAddUrl(file.external_link)}
                    target={"_blank"}
                  >
                    <ButtonPrimary>{file.name}</ButtonPrimary>
                  </a>
                );
              })
            : null}
        </div>
      </div>
    );
  }
  return (
    <div>
      <h3 className={"uppercase pt-5 border-t border-grey"}>Internal Note</h3>
      <Field
        name="company_note"
        label=""
        component={Textarea}
        rows={6}
        wrapperClassName="w-full "
        placeholder="Add a company note"
        onChange={e => setContent(e.target.value)}
        value={"test4231"}
      />
      <div className={"flex justify-end"}>
        {saving ? (
          <Loading small dark inline />
        ) : (
          <span>
            {updatedBy ? "Updated by " + updatedBy : null}{" "}
            {updatedAt
              ? " at " + moment(updatedAt).format("DD/MM/YYYY h:mm:ss")
              : null}{" "}
          </span>
        )}
      </div>
    </div>
  );
};

CompanyNoteField = reduxForm({
  form: "companyForm",
  enableReinitialize: true,
  destroyOnUnmount: false,
})(CompanyNoteField);

export default connect(mapStateToProps, mapDispatchToProps)(CompanyNoteField);
